import { render } from "./Assistant.component.vue?vue&type=template&id=98b744c2&scoped=true"
import script from "./Assistant.component.vue?vue&type=script&lang=js"
export * from "./Assistant.component.vue?vue&type=script&lang=js"

import "./Assistant.component.vue?vue&type=style&index=0&id=98b744c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b744c2"]])

export default __exports__